import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

export const Separator = styled(Box).attrs(({ ml = 0, mr = 0 }) => ({
  height: '16px',
  ml,
  mr,
  width: '1px',
}))`
  background-color: ${({ theme }) => theme.colors.horizon};
  border-radius: 1px;
`;
